// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wdk9y","menuAtivo":"styles_menuAtivo__7nPxG","menuItemText":"styles_menuItemText__IViaC"};